module.exports = __webpack_public_path__ + "img/3.f4ed36a7.jpeg";